const axios = require('axios');
const { errorMapper } = require('../ErrorMapper');

const CURRENT_VERSION = 'v1';

class FinancialReportingServiceConnector {
  constructor(configuration) {
    this.httpClient = axios.create(configuration);
  }

  async generateDisputeReport({ filename, lang, sort, ...options }) {
    try {
      const request = {
        url: `/${CURRENT_VERSION}/reports/disputes?lang=${lang}`,
        method: 'POST',
        data: {
          filename,
          sort,
          ...options,
        },
      };

      const { data } = await this.httpClient(request);
      return data;
    } catch (error) {
      return this._handleError(error);
    }
  }

  async generateRefundReport({ filename, lang, sort, ...options }) {
    try {
      const request = {
        url: `/${CURRENT_VERSION}/reports/refunds?lang=${lang}`,
        method: 'POST',
        data: {
          filename,
          sort,
          ...options,
        },
      };

      const { data } = await this.httpClient(request);
      return data;
    } catch (error) {
      return this._handleError(error);
    }
  }

  async generateCaptureReport({ filename, lang, timezone, sort, ...options }) {

    const queryParams = {
      lang,
      timezone,
    };

    try {
      const request = {
        url: `/${CURRENT_VERSION}/reports/captures`,
        method: 'POST',
        params: queryParams,
        data: {
          filename,
          sort,
          ...options,
        },
      };

      const { data } = await this.httpClient(request);
      return data;
    } catch (error) {
      return this._handleError(error);
    }
  }

  async generateFailedCaptureReport({ filename, lang, sort, ...options }) {
    try {
      const request = {
        url: `/${CURRENT_VERSION}/reports/failed-captures?lang=${lang}`,
        method: 'POST',
        data: {
          filename,
          sort,
          ...options,
        },
      };

      const { data } = await this.httpClient(request);
      return data;
    } catch (error) {
      return this._handleError(error);
    }
  }

  async generatePayoutReport({ filename, lang, timezone, sort, ...options }) {
    const queryParams = {
      lang,
      timezone,
    };

    try {
      const request = {
        url: `/${CURRENT_VERSION}/reports/payouts`,
        method: 'POST',
        params: queryParams,
        data: {
          filename,
          sort,
          ...options,
        },
      };

      const { data } = await this.httpClient(request);
      return data;
    } catch (error) {
      return this._handleError(error);
    }
  }

  _handleError(error) {
    throw errorMapper(error);
  }
}

module.exports = {
  FinancialReportingServiceConnector,
};
